<template>
  <intersect @enter="animate = true">
    <div>
        <router-link :to="$store.getters.getSingleUrl(transfer,1)" 
        class="mTransfer-box fadeUp" 
        :class="animate ? 'animate' : ''"
        v-for="(transfer, index) in itemData" :key="index"  v-if="transfer.id != current">
          <picture>
            <!-- <source media="(max-width: 767px)" srcset="@/assets/img/mt-bg.jpg" />
            <source media="(max-width: 1023px)" srcset="@/assets/img/mt-bg.jpg" /> -->
            <img v-if="_.get(transfer, 'hover_image.0.url')" :src="_.get(transfer, 'hover_image.0.url')" class="img-absolute" alt />
          </picture>
          <span class="img-layer"></span>
          <div class="top">
            <img v-if="_.get(transfer , 'logo')" :src="_.get(transfer , 'logo.0.url')" alt />
          </div>
          <div class="content">
            <h2 class="noto-semibold ttl">{{transfer.title}}</h2>
            <div class="txt">{{transfer.teaser}}</div>
            <div v-if="transfer.status && transfer.status !== 'none'" class="txt error">{{$fn.tr(transfer.status)}}</div>
            <!-- <div v-else></div> -->
          </div>
          <div class="bottom">
            <div class="line-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="726.5" height="1" viewBox="0 0 726.5 0.5">
                <line
                  id="Line_27"
                  data-name="Line 27"
                  x2="726"
                  transform="translate(0.25 0.25)"
                  fill="none"
                  stroke="#bcbec0"
                  stroke-linecap="round"
                  stroke-width="0.5"
                  stroke-dasharray="10"
                />
              </svg>
            </div>
            <div class="whiteRed-btn">
              <span class="noto-semibold">{{$fn.tr("Discover more")}}</span>
            </div>
          </div>
        </router-link>
    </div>
  </intersect>
</template>

<script>
import Intersect from 'vue-intersect'
export default {
  components: { 
    Intersect
  },
  props: {
    itemData: Array,
    current: Number,
  },
  data(){
    return{
      animate: false
    }
  }
};
</script>
